export default "__VITE_ASSET__C8uCgNxu__"